var map = {
	"./athletic_bilbao.png": 2085,
	"./atletico_de_madrid.png": 1944,
	"./ca_osasuna.png": 1426,
	"./cd_leganes.png": 2118,
	"./celta_de_vigo.png": 670,
	"./deportivo_alaves.png": 4174,
	"./fc_barcelona.png": 6092,
	"./getafe_cf.png": 9365,
	"./girona_fc.png": 2435,
	"./rayo_vallecano.png": 7500,
	"./rcd_espanyol_barcelona.png": 4956,
	"./rcd_mallorca.png": 9464,
	"./real_betis_balompie.png": 3945,
	"./real_madrid.png": 6339,
	"./real_sociedad.png": 9266,
	"./real_valladolid_cf.png": 6960,
	"./sevilla_fc.png": 969,
	"./ud_las_palmas.png": 3138,
	"./valencia_cf.png": 1700,
	"./villarreal_cf.png": 4129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 614;